import React from 'react';
import './index.scss';

interface IExternalLinkProps {
  title?: string;
  linkUrl: string;
  linkText: string;
}

const ExternalLink: React.FC<IExternalLinkProps> = props => {
  const { title, linkUrl, linkText } = props;
  return (
    <div className="external_link">
      {title && <div className="external_link_title">{title}</div>}
      <a href={linkUrl} target="_blank" rel="noopener noreferrer">
        {linkText}
      </a>
    </div>
  );
};

export default ExternalLink;
